import React from "react";
import ItemList from "./ItemList";

const RestaurentCategory = ({ data, showIndex, setShowIndex }) => {
  const handleShowItemList = () => {
    setShowIndex();
  };
  return (
    <div className="w-6/12 mx-auto my-4 bg-gray-50 p-4 shadow-lg">
      <div
        className="flex items-center justify-between cursor-pointer"
        onClick={handleShowItemList}
      >
        <h3 className="text-decor font-bold text-lg">
          {data.title} ({data?.itemCards.length})
        </h3>
        <p>▼</p>
      </div>
      {showIndex && <ItemList items={data?.itemCards} />}
    </div>
  );
};

export default RestaurentCategory;
